export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_06.33aa5511.jpg";